module.exports = __webpack_public_path__ + "static/img/planRight9.a1817bb0.png";